import { isAllNull } from '@utils/isAllNull/isAllNull';

/**
 *  Unwraps the first value from an array, checking if it is all null properties or not
 *
 * useful if we expect an array of length1 and it should be non-null.
 *
 * # Note
 * ACTS AS AN IDENTITY WITH PRIMITIVES, AND LOGS A TRACE IF A PRIMITIVE IS PASSED.
 *  */
export function unwrap<T extends WrappedObjType>(
  agg: [T] | [] | null | undefined,
): T | undefined {
  if (!agg) return undefined;
  const [val] = agg;
  if (typeof val === 'undefined') return undefined; // Just in case the api returns empty array.
  if (typeof val !== 'object' || val === null) {
    console.trace('Tried to use unwrap with a primitive', val);
    return val; // Handle the case where we pass strings or such
  }
  const isNullOrEmptyValue = isAllNull(val);
  // If none of its properties are available
  if (isNullOrEmptyValue) return undefined;
  return val;
}
export type WrappedObjType = Parameters<typeof Object.values>[0];
